import React from 'react';
import { observer } from 'mobx-react';
import { useMst, PageRoutes } from '../../../internal';
import {
  QuizApiItem,
  QuizQuestionApiItem,
  quizImageUrl,
} from '../../../utils/api/QuizApi';
import { Button } from '../../../components/UI/buttons/regular/Button';
import { dateSRLocale } from '../../../utils/date';
import trashIcon from '../../../assets/icons/icons8_trash_32px.png';
import styles from './Pitanja.module.scss';

export const Pitanja = observer((): JSX.Element => {
  const {
    currentPage,
    router: { navigate },
  } = useMst();

  return (
    <div className={styles.PageContainer}>
      <div className={styles.Selector}>
        <label>Kviz</label>
        <select
          value={currentPage.selectedQuizId ?? ''}
          onChange={(e) => currentPage.selectQuiz(Number(e.target.value))}
        >
          <option value="" disabled>
            Izaberi kviz
          </option>
          {currentPage.quizzes.map((quiz: QuizApiItem) => (
            <option key={quiz.id} value={quiz.id}>
              {quiz.name}
            </option>
          ))}
        </select>
      </div>

      {currentPage.selectedQuizId && (
        <>
          <table className={styles.Table}>
            <thead>
              <tr>
                <th>Tekst pitanja</th>
                <th>Status</th>
                <th>Kreiran</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {currentPage.questions.map((question: QuizQuestionApiItem) => (
                <tr key={question.id}>
                  <td>
                    {question.image && (
                      <img
                        src={quizImageUrl(question.image)}
                        alt=""
                        className={styles.Thumbnail}
                      />
                    )}
                    <span
                      className={styles.NameLink}
                      onClick={() =>
                        navigate({
                          newView: PageRoutes.PitanjeDetalji.id,
                          queryParams: {
                            quizId: currentPage.selectedQuizId,
                            id: question.id,
                          },
                        })
                      }
                    >
                      {question.questionText}
                    </span>
                  </td>
                  <td>
                    <span
                      className={
                        question.isActive
                          ? styles.BadgeActive
                          : styles.BadgeInactive
                      }
                      onClick={() =>
                        currentPage.toggleQuestionActive(
                          question.id,
                          question.isActive
                        )
                      }
                    >
                      {question.isActive ? 'Aktivno' : 'Neaktivno'}
                    </span>
                  </td>
                  <td>{dateSRLocale(new Date(question.createdAt))}</td>
                  <td>
                    <img
                      src={trashIcon}
                      alt="Obriši"
                      className={styles.DeleteIcon}
                      onClick={() => currentPage.deleteQuestion(question.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={styles.AddButton}>
            <Button
              onClick={() =>
                navigate({
                  newView: PageRoutes.KreirajPitanje.id,
                  queryParams: { quizId: currentPage.selectedQuizId },
                })
              }
            >
              Dodaj novo
            </Button>
          </div>
        </>
      )}
    </div>
  );
});
